import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "font-display font-extrabold text-3xl text-mainGreen mb-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.modalTitle), 1),
      _createElementVNode("div", {
        class: "font-display font-extrabold text-3xl text-mainRed cursor-pointer absolute right-10 top-10",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
      }, " x "),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}